export default {
    setRitten(state, payload){
        state.ritten = payload;
    },

    setPages(state, payload){
        state.pages = payload;
    }
}